import { type Project, type Contact } from '@/generated/graphql';

export const BudgetHealthReportTypes = {
	TIME: 'time',
	REVENUE: 'revenue',
} as const;

export const ChartZoneClasses = {
	OverActual: 'burn-up-chart__over-budget--actual',
	OverPlanned: 'burn-up-chart__over-budget--planned',
} as const;

export type ChartProgressGroup = {
	budgetValue: number;
	groupName: string;
	actualValue: number;
	forecastedValue: number;
	plannedValue: number;
	actualCost: number;
	actualRevenue: number;
	bookingsCost: number;
	costBudget: number;
	forecastedCost: number;
	forecastedRevenue: number;
	monetaryBudget: number;
	tasksCost: number;
};

export type ChartProject =
	| (Pick<Project, 'id' | 'deadline' | 'date'> &
			Partial<Pick<Project, 'revenueCalcModel'>> & {
				progressData?: ChartProgressGroup[];
			} & {
				company?: Pick<Contact, 'id' | 'type'> | null;
			})
	| null;
